import React from 'react';

import { DropdownItemGroup } from '@atlaskit/dropdown-menu';

import { useContentStatus } from '@confluence/page-utils/entry-points/useContentStatus';
import { usePageContentId } from '@confluence/page-context';
import { OperationTypes, useCanPerformContentOperation } from '@confluence/entity-operations';

import { CommentBulkReadWithFlags } from './CommentBulkRead';
import { CommentBulkResolveWithFlags } from './CommentBulkResolve';

export const CommentBulkActions = () => {
	const [contentId = ''] = usePageContentId();
	const { contentStatus = '' } = useContentStatus();

	const [canPerformResolveAllComments] = useCanPerformContentOperation({
		contentId,
		contentType: 'comment',
		status: [contentStatus],
		operation: OperationTypes.CREATE,
	});

	return (
		<DropdownItemGroup hasSeparator>
			<CommentBulkReadWithFlags />
			{canPerformResolveAllComments && <CommentBulkResolveWithFlags />}
		</DropdownItemGroup>
	);
};
